export const CORP_ONLY_MIN_YEARS_IN_BUSINESS = 7;

export const SUBMISSION_MODE_FULL_GUARANTOR = "FULL_GUARANTOR";
export const SUBMISSION_MODE_CORP_ONLY = "CORP_ONLY";

export const COMMERCIAL_LOANS_OPTIONS = [
  { value: "0", label: "0" },
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4", label: "4" },
  { value: "5_plus", label: "5+" },
] as const;

export type CommercialLoansBucket = (typeof COMMERCIAL_LOANS_OPTIONS)[number]["value"];

export function isSoleProprietorship(entityType: string | undefined | null): boolean {
  const normalized = (entityType || "").trim().toLowerCase();
  if (!normalized) return false;
  return normalized === "sole proprietorship" || normalized.includes("sole proprietorship");
}

export function corpOnlyHardGatePasses(
  yearsInBusiness: unknown,
  entityType: string | undefined | null,
): boolean {
  const yib = parseInt(String(yearsInBusiness ?? ""), 10);
  if (!Number.isFinite(yib) || yib < CORP_ONLY_MIN_YEARS_IN_BUSINESS) return false;
  if (isSoleProprietorship(entityType)) return false;
  return true;
}

export function commercialLoansAllowsCorpOnly(bucket: string | undefined | null): boolean {
  return bucket === "3" || bucket === "4" || bucket === "5_plus";
}

export function isCorpOnlyEligible(
  yearsInBusiness: unknown,
  entityType: string | undefined | null,
  commercialLoansBucket: string | undefined | null,
): boolean {
  return (
    corpOnlyHardGatePasses(yearsInBusiness, entityType) &&
    commercialLoansAllowsCorpOnly(commercialLoansBucket)
  );
}

export function normalizeSubmissionMode(raw: unknown): string {
  const v = String(raw ?? "")
    .trim()
    .toUpperCase()
    .replace(/-/g, "_");
  if (v === "CORP_ONLY" || v === "CORPONLY" || v === "CORPORATE_ONLY") {
    return SUBMISSION_MODE_CORP_ONLY;
  }
  return SUBMISSION_MODE_FULL_GUARANTOR;
}
